import styles from './BusinessChallenge.module.css';
import { BusinessChallengeDivider } from './BusinessChallengeDivider';
import { getTextParts, isHighlightedPhrase } from './helpers';

type BusinessChallengeProps = {
  text: string;
  highlightedPhrases: string[];
};

export const BusinessChallenge = ({ text, highlightedPhrases }: BusinessChallengeProps) => {
  const textPartsByHighlighting = getTextParts(text, highlightedPhrases);

  return (
    <div className={styles.sectionRoot}>
      <BusinessChallengeDivider side='left' />
      <div className={styles.sectionContent}>
        <h3 className={styles.businessChallengeHeading}>Business Challenge</h3>
        <p className={styles.businessChallengeText}>
          {textPartsByHighlighting.map((textPart, index) =>
            isHighlightedPhrase(textPart, highlightedPhrases) ? (
              <span key={index} className={styles['businessChallengeText--highlighted']}>
                {textPart}
              </span>
            ) : (
              textPart
            ),
          )}
        </p>
      </div>
      <BusinessChallengeDivider side='right' />
    </div>
  );
};
